import React from "react";
import NewPass from "../Components/Login/NewPass";

const NewPassPage = () => {
  return <NewPass />;
};

export default NewPassPage;
